module.exports = __webpack_public_path__ + "img/facebook2.7a34bd49.svg";